import { Action } from 'redux';
import { Consultorio } from '../../../models/Entities/Turnero';
import { TurneroConsultoriosState, TurneroConsultoriosUnloadState } from '../../states/Turnero-Consultorios.State';

export default function TurneroConsultoriosReducer(
    state: TurneroConsultoriosState | undefined,
    action: Action
): TurneroConsultoriosState {
    const currentState = state ?? TurneroConsultoriosUnloadState;
    const a: any = action;

    switch (a.type) {
        case 'TURNERO-CONSULTORIOS_GET_ALL_REQUEST':
            return {
                ...currentState,
                isLoadingAll: true,
                successLoadingAll: false,
                failOnLoadingAll: false,
                error: undefined
            } as TurneroConsultoriosState;
        case 'TURNERO-CONSULTORIOS_GET_ALL_SUCCESS':
            return {
                ...currentState,
                isLoadingAll: false,
                successLoadingAll: true,
                failOnLoadingAll: false,
                error: undefined,
                list: a.payload || []
            } as TurneroConsultoriosState;
        case 'TURNERO-CONSULTORIOS_GET_ALL_FAILURE':
            return {
                ...currentState,
                isLoadingAll: false,
                successLoadingAll: false,
                failOnLoadingAll: true,
                error: a.error
            } as TurneroConsultoriosState;

        case 'TURNERO-CONSULTORIOS_CREATE_REQUEST':
            return {
                ...currentState,
                isAddingNewOne: true,
                successAddingNewOne: false,
                failOnAddingNewOne: false,
                error: undefined
            } as TurneroConsultoriosState;
        case 'TURNERO-CONSULTORIOS_CREATE_SUCCESS':
            return {
                ...currentState,
                isAddingNewOne: false,
                successAddingNewOne: true,
                failOnAddingNewOne: false,
                error: undefined,
                list: [...(currentState.list || []), a.payload]
            } as TurneroConsultoriosState;
        case 'TURNERO-CONSULTORIOS_CREATE_FAILURE':
            return {
                ...currentState,
                isAddingNewOne: false,
                successAddingNewOne: false,
                failOnAddingNewOne: true,
                error: a.error
            } as TurneroConsultoriosState;

        case 'TURNERO-CONSULTORIOS_GET_DISPONIBLES_REQUEST':
            return {
                ...currentState,
                isLoadingDisponibles: true,
                successLoadingDisponibles: false,
                failOnLoadingDisponibles: false,
                error: undefined
            } as TurneroConsultoriosState;
        case 'TURNERO-CONSULTORIOS_GET_DISPONIBLES_SUCCESS':
            return {
                ...currentState,
                isLoadingDisponibles: false,
                successLoadingDisponibles: true,
                failOnLoadingDisponibles: false,
                error: undefined,
                disponibles: a.payload || []
            } as TurneroConsultoriosState;
        case 'TURNERO-CONSULTORIOS_GET_DISPONIBLES_FAILURE':
            return {
                ...currentState,
                isLoadingDisponibles: false,
                successLoadingDisponibles: false,
                failOnLoadingDisponibles: true,
                error: a.error
            } as TurneroConsultoriosState;

        case 'TURNERO-CONSULTORIOS_GET_DISPONIBLES_DOCTOR_REQUEST':
            return {
                ...currentState,
                isLoadingDisponiblesDoctor: true,
                successLoadingDisponiblesDoctor: false,
                failOnLoadingDisponiblesDoctor: false,
                error: undefined
            } as TurneroConsultoriosState;
        case 'TURNERO-CONSULTORIOS_GET_DISPONIBLES_DOCTOR_SUCCESS':
            return {
                ...currentState,
                isLoadingDisponiblesDoctor: false,
                successLoadingDisponiblesDoctor: true,
                failOnLoadingDisponiblesDoctor: false,
                error: undefined,
                disponiblesPorDoctor: a.payload || []
            } as TurneroConsultoriosState;
        case 'TURNERO-CONSULTORIOS_GET_DISPONIBLES_DOCTOR_FAILURE':
            return {
                ...currentState,
                isLoadingDisponiblesDoctor: false,
                successLoadingDisponiblesDoctor: false,
                failOnLoadingDisponiblesDoctor: true,
                error: a.error
            } as TurneroConsultoriosState;

        case 'TURNERO-CONSULTORIOS_UPDATE_REQUEST':
            return {
                ...currentState,
                isUpdatingOne: true,
                successUpdatingOne: false,
                failOnUpdatingOne: false,
                error: undefined
            } as TurneroConsultoriosState;
        case 'TURNERO-CONSULTORIOS_UPDATE_SUCCESS': {
            const updatedList = [...(currentState.list || []).filter((c: Consultorio) => c.id !== a.id), a.consultorio];
            return {
                ...currentState,
                isUpdatingOne: false,
                successUpdatingOne: true,
                failOnUpdatingOne: false,
                error: undefined,
                list: updatedList
            } as TurneroConsultoriosState;
        }
        case 'TURNERO-CONSULTORIOS_UPDATE_FAILURE':
            return {
                ...currentState,
                isUpdatingOne: false,
                successUpdatingOne: false,
                failOnUpdatingOne: true,
                error: a.error
            } as TurneroConsultoriosState;

        case 'TURNERO-CONSULTORIOS_DELETE_REQUEST':
            return {
                ...currentState,
                isDeletingOne: true,
                successDeletingOne: false,
                failOnDeletingOne: false,
                error: undefined
            } as TurneroConsultoriosState;
        case 'TURNERO-CONSULTORIOS_DELETE_SUCCESS':
            return {
                ...currentState,
                isDeletingOne: false,
                successDeletingOne: true,
                failOnDeletingOne: false,
                error: undefined,
                list: (currentState.list || []).filter((c: Consultorio) => c.id !== a.payload)
            } as TurneroConsultoriosState;
        case 'TURNERO-CONSULTORIOS_DELETE_FAILURE':
            return {
                ...currentState,
                isDeletingOne: false,
                successDeletingOne: false,
                failOnDeletingOne: true,
                error: a.error
            } as TurneroConsultoriosState;

        case 'TURNERO-CONSULTORIOS_UPDATE_ESTADO_REQUEST':
            return {
                ...currentState,
                isUpdatingEstado: true,
                successUpdatingEstado: false,
                failOnUpdatingEstado: false,
                error: undefined
            } as TurneroConsultoriosState;
        case 'TURNERO-CONSULTORIOS_UPDATE_ESTADO_SUCCESS': {
            const updatedList = (currentState.list || []).map((c: Consultorio) =>
                c.id === a.id ? { ...c, status: a.estado } : c
            );
            return {
                ...currentState,
                isUpdatingEstado: false,
                successUpdatingEstado: true,
                failOnUpdatingEstado: false,
                error: undefined,
                list: updatedList
            } as TurneroConsultoriosState;
        }
        case 'TURNERO-CONSULTORIOS_UPDATE_ESTADO_FAILURE':
            return {
                ...currentState,
                isUpdatingEstado: false,
                successUpdatingEstado: false,
                failOnUpdatingEstado: true,
                error: a.error
            } as TurneroConsultoriosState;

        default:
            return currentState as TurneroConsultoriosState;
    }
}
